import O1HD from "../../../engines/gameEngine";
import userService from "../../../engines/services/userService";

const {ccclass, property} = cc._decorator;

@ccclass
export default class AmbryItem extends cc.Component {

    @property(cc.Sprite)
    iconSpirit : cc.Sprite = null;
    @property(cc.Mask)
    maskNode : cc.Mask = null;
    @property(cc.Label)
    lbName : cc.Label = null;

    private mZodiacStr : string;
    // onLoad () {}

    start () {
        O1HD.on( "AmbryItem.activeZodiac" , this.activeZodiac , this );
    }

    bindData( zodiacStr : string ){
       this.mZodiacStr = zodiacStr;
       this.lbName.string = `${this.mZodiacStr}`;
       O1HD.getManagers().gameMgr.getCurrMode().bundle.load(`res/chineseZodiac/${this.mZodiacStr}`,cc.SpriteFrame,( error , assets : cc.SpriteFrame )=>{
           if ( error ){
               console.log(`橱柜 item加载不到资源图片 ${this.mZodiacStr}`);
               return;
           }
           this.iconSpirit.spriteFrame = assets;
           this.maskNode.spriteFrame = assets;
           let zodiacArrayStr = userService.mZodiacData;
           if ( !zodiacArrayStr ) {

           }else{
                if ( zodiacArrayStr.includes( zodiacStr ) ) {
                    this.maskNode.node.active = false;
                }
           }
       })
    }

    /**
     * 激活
     * @param zodiac
     */
    activeZodiac( zodiac : string ){
        if ( zodiac == this.mZodiacStr ) {
            this.maskNode.node.active = false;
        }
    }
}
